module.exports = "/_next/static/images/1986262c1917e7f6894a6692251e1844-nu-fifa-logo@3x.png.webp";